import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/lib/SiteContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import Author from "@/pages/Author";
import Chronicles, { ChronicleReader } from "@/pages/Chronicles";
import Daily, { DailyReader } from "@/pages/Daily";
import Appearances from "@/pages/Appearances";
import Connect from "@/pages/Connect";
import NotFound from "@/pages/NotFound";
import Bookstore, { VolumeOne } from "@/pages/Bookstore";
import Merch, { MerchCategory, MerchProduct } from "@/pages/Merch";
import Cart from "@/pages/Cart";
import Account, { OrderStatus } from "@/pages/Account";
import CinemaHome from "@/pages/studio/CinemaHome";
import Division from "@/pages/studio/Division";
import Watch from "@/pages/studio/Watch";
import SeriesPage from "@/pages/studio/Series";
import { CartProvider } from "@/lib/CartContext";
import Admin from "@/pages/admin/Admin";
import AuthCallback from "@/pages/admin/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SiteLayout() {
  return (
    <>
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Book />} />
          <Route path="/author" element={<Author />} />
          <Route path="/chronicles" element={<Chronicles />} />
          <Route path="/chronicles/:id" element={<ChronicleReader />} />
          <Route path="/daily" element={<Daily />} />
          <Route path="/daily/:slug" element={<DailyReader />} />
          <Route path="/cinema" element={<CinemaHome />} />
          <Route path="/cinema/watch/:slug" element={<Watch />} />
          <Route path="/cinema/series/:slug" element={<SeriesPage />} />
          <Route path="/cinema/:division" element={<Division />} />
          <Route path="/appearances" element={<Appearances />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/bookstore" element={<Bookstore />} />
          <Route path="/bookstore/volume-one" element={<VolumeOne />} />
          <Route path="/merch" element={<Merch />} />
          <Route path="/merch/product/:id" element={<MerchProduct />} />
          <Route path="/merch/:category" element={<MerchCategory />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/account" element={<Account />} />
          <Route path="/order-status" element={<OrderStatus />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <CartProvider>
            <SmoothScroll>
              <ErrorBoundary>
                <AppRouter />
              </ErrorBoundary>
            </SmoothScroll>
          </CartProvider>
          <Toaster theme="dark" position="bottom-center" />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
